export default __webpack_public_path__ + "static/media/233.4500dcf0.jpg";